/** Shared types for the fixture detail screen. */

export type MarketState = 'hit' | 'miss' | 'ontrack' | 'offtrack' | 'open';

export interface CardRow {
  label: string;
  value: string;
  state: MarketState;
  /** "+50" for the base, "×1.4"/"÷1.4" for a boost. */
  factor: string;
}

export const STATE_LABEL: Record<MarketState, string> = {
  hit: 'hit',
  miss: 'miss',
  ontrack: 'hitting',
  offtrack: 'pending',
  open: 'open'
};
